const isEmbed = (): boolean => {
    return location.pathname.indexOf('/embed') === 0
}

export default isEmbed
